import { render, staticRenderFns } from "./r-task-config-dialog.vue?vue&type=template&id=59967d4c&scoped=true"
import script from "./r-task-config-dialog.vue?vue&type=script&lang=js"
export * from "./r-task-config-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-task-config-dialog.vue?vue&type=style&index=0&id=59967d4c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59967d4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59967d4c')) {
      api.createRecord('59967d4c', component.options)
    } else {
      api.reload('59967d4c', component.options)
    }
    module.hot.accept("./r-task-config-dialog.vue?vue&type=template&id=59967d4c&scoped=true", function () {
      api.rerender('59967d4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/worker/r-task-config-dialog.vue"
export default component.exports